import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Store } from '@ngrx/store';
import { Observable, of, combineLatest } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { hasPermission } from '../../core/permissions/permission.selector';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private store: Store
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.authService.isLoggedIn().pipe(
      switchMap(() => {
        const authToken = sessionStorage.getItem('AUTH_TOKEN');
        const isLoggedIn = !!authToken;

        if (
          !isLoggedIn ||
          (authToken && this.authService.isTokenExpired(authToken))
        ) {
          this.authService.handleInvalidToken();
          return of(false);
        }

        const requiredPermission = route.data['requiredPermission'];
        if (!requiredPermission) {
          return of(true);
        }

        return this.store.select(hasPermission(requiredPermission)).pipe(
          map((hasPerm) => {
            if (!hasPerm) {
              this.router.navigate(['/dashboard']);
              return false;
            }
            return true;
          })
        );
      }),
      tap((isAllowed) => {
        if (!isAllowed) {
          sessionStorage.removeItem('AUTH_TOKEN');
          sessionStorage.removeItem('AUTH_TOKEN');
          this.router.navigate(['/login']);
        }
      })
    );
  }
}
